import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const taskApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addtask: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addTask,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    gettasks: builder.query({
      query: ({ search, limit, page, user_role }) => {
        return {
          url: `${API_ROUTE.getTasks}/${user_role}/tasks?search=${search}&limit=${limit}&page=${page}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updatetask: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateTask}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deletetask: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteTask}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    completionStatus: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.completionSatus}/${user.id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const {
  useAddtaskMutation,
  useGettasksQuery,
  useUpdatetaskMutation,
  useDeletetaskMutation,
  useCompletionStatusMutation,
} = taskApi;
